import Endpoint from "../../services/api/endpoint";
import { IShop } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IShop>(Endpoint.Shops, Endpoint.ShopsList);